export const id = {
  company: {
    name: "PT Prima Cipta Artifisial",
    shortName: "Prima AI",
    tagline: "Pionir Solusi Integrasi AI & Otomasi Cerdas Perusahaan",
    description:
      "PT Prima Cipta Artifisial adalah perusahaan penyedia solusi integrasi Artificial Intelligence (AI) terkemuka di Indonesia. Kami menjembatani teknologi AI mutakhir dengan ekosistem bisnis Anda untuk menciptakan efisiensi tanpa batas, otomatisasi alur kerja cerdas, dan keunggulan kompetitif yang terukur.",
    address: "GEDUNG FANCY MAMPANG, JL. MAMPANG PRPT. RAYA NO.151 LT 4 UNIT A7, DUREN TIGA, PANCORAN, 12760",
    email: "sales@ciptaartifisial.com",
    phone: "+628211977117",
    whatsapp: "+628211977117",
  },
  nav: {
    home: "Beranda",
    about: "Tentang Kami",
    services: "Layanan AI",
    projects: "Solusi",
    contact: "Hubungi Kami",
    consultation: "Konsultasi Gratis",
  },
  hero: {
    badge: "Solusi Integrasi AI Terpercaya",
    title: "Akselerasi Bisnis Anda dengan Integrasi AI Cerdas & Terukur",
    subtitle:
      "Kami mengintegrasikan model AI, Large Language Model (LLM), Agentic Workflows, dan Computer Vision ke dalam infrastruktur ERP, CRM, dan sistem operasional bisnis Anda secara aman dan seamless.",
    ctaPrimary: "Mulai Transformasi AI",
    ctaSecondary: "Pelajari Layanan Kami",
    features: [
      {
        title: "Integrasi Sistem Enterprise",
        desc: "Konektivitas instan ke SAP, Odoo, Oracle, CRM, API internal tanpa merombak arsitektur lama.",
      },
      {
        title: "Privat, Aman & Terenkripsi",
        desc: "Deployment on-premise atau private cloud dengan standar keamanan data dan kepatuhan perbankan.",
      },
      {
        title: "Autonomous Agentic AI",
        desc: "Otomasi alur kerja multi-langkah cerdas yang mampu mengambil aksi nyata 24/7.",
      },
    ],
  },
  about: {
    sectionSub: "Siapa Kami?",
    headline1: "Kami membantu",
    headline2: "akselerasi bisnis dan",
    headline3: "skalabilitas dengan solusi integrasi AI",
    title: "Membantu Perusahaan Bertumbuh dengan Kekuatan Integrasi AI Generatif & Otomasi Cerdas",
    desc1:
      "PT Prima Cipta Artifisial lahir dari komitmen untuk menjadikan kecerdasan buatan sebagai penggerak nyata pertumbuhan bisnis di Indonesia dan Asia Tenggara. Kami bukan sekadar penyedia software, melainkan mitra integrasi teknologi strategis yang mendampingi perusahaan dari tahap asesmen, perancangan arsitektur, hingga deployment skala enterprise.",
    desc2:
      "Dengan keahlian mendalam pada Large Language Models, Retrieval-Augmented Generation (RAG), Computer Vision, dan Autonomous Agentic Workflows, kami menjamin solusi AI yang terintegrasi secara mulus, aman dari kebocoran data, dan memberikan dampak Return on Investment (ROI) yang jelas.",
    visionTitle: "Visi Kami",
    visionDesc:
      "Menjadi perusahaan integrasi AI nomor satu di Asia Tenggara yang memberdayakan setiap lini industri menuju otomatisasi cerdas berstandar global.",
    missionTitle: "Misi Kami",
    missionDesc:
      "Mengembangkan dan mengintegrasikan solusi AI yang aman, etis, dan berdampak nyata bagi produktivitas serta profitabilitas bisnis mitra kami.",
    whyUsSub: "Mengapa Memilih Kami?",
    whyUsTitle: "Keunggulan PT Prima Cipta Artifisial",
    whyUs: [
      {
        title: "Keamanan Data & Kepatuhan Penuh",
        desc: "Arsitektur Zero-Data-Retention dan isolasi data privat, memenuhi standar regulasi data nasional dan internasional.",
      },
      {
        title: "Tim Spesialis AI Berpengalaman",
        desc: "Didukung oleh AI engineer, data scientist, dan arsitek sistem bersertifikasi internasional.",
      },
      {
        title: "Solusi Kustom & Siap Skala",
        desc: "Setiap solusi disesuaikan secara presisi dengan kebutuhan unik dan sistem legacy bisnis Anda.",
      },
      {
        title: "ROI & Metrik Terukur",
        desc: "Fokus pada efisiensi biaya, percepatan waktu proses, dan peningkatan akurasi nyata.",
      },
    ],
  },
  services: {
    sectionSub: "Layanan Unggulan",
    title: "Solusi Integrasi AI Komprehensif untuk Transformasi Digital Anda",
    viewAll: "Lihat Semua Layanan",
    items: [
      {
        id: 1,
        slug: "enterprise-ai-integration",
        title: "Enterprise AI & LLM Integration",
        shortDesc:
          "Integrasikan LLM dan generative AI ke dalam core system (ERP, CRM, Database, REST API) untuk akses data berbasis natural language.",
        fullDesc:
          "Kami menghubungkan fondasi model AI tercanggih dengan sistem ERP (SAP, Oracle), CRM (Salesforce, HubSpot), database terdistribusi, serta aplikasi internal. Memungkinkan seluruh tim Anda berinteraksi dengan data operasional dan menghasilkan laporan analitis hanya melalui percakapan natural language.",
        features: [
          "Integrasi SAP / Oracle ERP",
          "Private RAG Knowledge Base",
          "Role-based Access Control (RBAC)",
          "Audit Trail & Log Enkripsi",
        ],
      },
      {
        id: 2,
        slug: "agentic-workflow-automation",
        title: "Autonomous Agentic Workflows",
        shortDesc:
          "Agen AI cerdas berkemampuan multi-langkah untuk mengotomatisasi pekerjaan kompleks secara mandiri dan akurat 24/7.",
        fullDesc:
          "Solusi agen AI otonom yang mampu melakukan penalaran logis, merencanakan langkah penyelesaian masalah, memanggil API eksternal, dan menyelesaikan alur kerja bisnis tanpa intervensi manual berulang.",
        features: [
          "Multi-Agent Collaborative System",
          "Autonomous Tool Execution",
          "Human-in-the-loop Fallback",
          "Error Recovery Otomatis",
        ],
      },
      {
        id: 3,
        slug: "omnichannel-conversational-ai",
        title: "Omnichannel Conversational AI",
        shortDesc:
          "Chatbot & Voice Assistant generasi baru untuk WhatsApp, Web, dan Contact Center dengan integrasi aksi transaksi.",
        fullDesc:
          "Bangun asisten virtual interaktif di WhatsApp Business API, Telegram, aplikasi mobile, dan website yang tidak hanya menjawab pertanyaan FAQ, namun juga mampu memeriksa saldo, cek resi, memproses transaksi, dan membuat tiket helpdesk otomatis.",
        features: [
          "Integrasi WhatsApp Business API",
          "Voice & Speech Recognition AI",
          "Live Ticket CRM Dispatching",
          "Analisis Sentimen Real-Time",
        ],
      },
      {
        id: 4,
        slug: "intelligent-document-processing",
        title: "Intelligent Document Processing (IDP)",
        shortDesc:
          "Ekstraksi dan validasi data dokumen, faktur, invoice, formulir, dan kontrak secara otomatis menggunakan AI Vision & OCR.",
        fullDesc:
          "Sistem ekstraksi dokumen berkekuatan AI Vision dan Transformer yang mampu mengenali dokumen terstruktur maupun tidak terstruktur (invoice, polis asuransi, KTP, dokumen legal) dengan akurasi di atas 99%, langsung disinkronkan ke sistem finansial Anda.",
        features: [
          "Pemrosesan Faktur & Invoice Otomatis",
          "Deteksi Keaslian & Anomali Dokumen",
          "Ekstraksi Multi-Bahasa & Format",
          "Ekspor Otomatis ke ERP/Akuntansi",
        ],
      },
      {
        id: 5,
        slug: "computer-vision-solutions",
        title: "Computer Vision & Edge AI",
        shortDesc:
          "Deteksi objek, inspeksi kualitas manufaktur, pengenalan visual, dan analisis CCTV waktu nyata berbasis Edge Device.",
        fullDesc:
          "Implementasi model deep learning pada kamera industri dan edge computing untuk inspeksi cacat produk manufaktur, pemantauan keselamatan kerja (K3), deteksi nomor plat kendaraan, dan analitik kepadatan area komersial.",
        features: [
          "Visual Quality Inspection 99.8%",
          "Pemantauan K3 & Alat Pelindung Diri",
          "Deployment Edge Device Rendah Latensi",
          "Integrasi PLC & Sistem SCADA",
        ],
      },
      {
        id: 6,
        slug: "predictive-analytics-ai",
        title: "Predictive Analytics & Data Science",
        shortDesc:
          "Model peramalan cerdas untuk estimasi permintaan pasar, deteksi fraud, dan optimasi harga dinamis.",
        fullDesc:
          "Manfaatkan data historis bisnis Anda dengan model machine learning prediktif untuk memproyeksikan permintaan stok, mengidentifikasi transaksi mencurigakan, menentukan strategi harga dinamis, serta mencegah churn pelanggan.",
        features: [
          "Prediksi Permintaan & Stok Cerdas",
          "Deteksi Dini Fraud Finansial",
          "Dynamic Pricing Algorithm",
          "Visualisasi Dashboard Interaktif",
        ],
      },
    ],
  },
  serviceDetails: {
    overviewBadge: "Detail Layanan",
    featuresTitle: "Fitur & Kapabilitas Utama",
    methodologyTitle: "Metodologi Integrasi AI",
    outcomesTitle: "Dampak Terukur & Hasil Implementasi",
    outcomesIntro: "Implementasi solusi oleh PT Prima Cipta Artifisial memberikan efisiensi tinggi, waktu respons instan, dan integrasi enterprise yang aman:",
    outcomesList: [
      "Integrasi LLM & ERP/CRM Terenkripsi.",
      "Otomasi Alur Kerja Multi-Agent 24/7.",
      "Pemrosesan Dokumen IDP Akurasi 99.4%.",
      "Arsitektur Data Scalable On-Premise / VPC.",
      "Pemantauan & Deteksi Anomali Real-Time.",
      "Dukungan Pengambilan Keputusan Bisnis Cerdas.",
    ],
    steps: [
      {
        id: 1,
        title: "01. Asesmen Arsitektur & Kesiapan Data",
        content:
          "Kami menganalisis alur kerja bisnis, API, dan basis data Anda (ERP, CRM, SQL/NoSQL) untuk mengidentifikasi titik temu integrasi AI dengan potensi dampak ROI tertinggi.",
      },
      {
        id: 2,
        title: "02. Prototyping Cepat & Proof of Concept (PoC)",
        content:
          "Membangun prototipe fungsional dalam 2–3 minggu untuk menguji akurasi model AI, kecepatan latensi query, dan kesesuaian integrasi dengan skenario kasus bisnis riil.",
      },
      {
        id: 3,
        title: "03. Integrasi Enterprise & Deployment Aman",
        content:
          "Deployment sistem ke lingkungan produksi (On-Premise atau Private VPC) dengan enkripsi end-to-end, isolasi data privat, dan integrasi RBAC terstandarisasi.",
      },
      {
        id: 4,
        title: "04. Monitoring 24/7, Fine-Tuning & Transfer Skill",
        content:
          "Pemantauan performa tanpa henti, penanganan model drift, pembaruan berkelanjutan, serta pelatihan intensif bagi tim internal perusahaan Anda.",
      },
    ],
    ctaTitle: "Tertarik Mengintegrasikan Solusi Ini?",
    ctaDesc: "Konsultasikan kebutuhan arsitektur sistem perusahaan Anda bersama tim spesialis AI kami secara gratis.",
  },
  industries: {
    sectionSub: "Sektor Industri",
    sectionTitle: "Transformasi AI Lintas Berbagai Industri Strategis",
    items: [
      { key: "banking", title: "Perbankan & Fintech" },
      { key: "manufacturing", title: "Manufaktur & Otomotif" },
      { key: "logistics", title: "Logistik & Supply Chain" },
      { key: "retail", title: "Retail & E-Commerce" },
      { key: "healthcare", title: "Kesehatan & Farmasi" },
      { key: "education", title: "Pendidikan & EdTech" },
      { key: "fmcg", title: "FMCG & Distribusi" },
    ],
  },
  industriesMarquee: {
    sectionSub: "Konektivitas & Keandalan",
    sectionTitle: "Integrasi AI Waktu-Nyata untuk Keunggulan Operasional",
    items: [
      { tag: "API:ERP", number: "99.8%", text: "Status Sinkronisasi SAP / Oracle Real-Time: TERHUBUNG" },
      { tag: "RAG:LLM", number: "<1.2s", text: "Latensi Inferensi Knowledge Base Enterprise" },
      { tag: "SECURITY", number: "AES-256", text: "Zero-Data-Retention & Isolasi Pipeline VPC" },
      { tag: "AGENT", number: "24/7", text: "Otomasi Alur Kerja Multi-Agent Aktif" },
    ],
  },
  projects: {
    sectionSub: "Studi Kasus & Portofolio",
    title: "Bukti Nyata Dampak Integrasi AI pada Berbagai Sektor Industri",
    viewAll: "Lihat Semua Studi Kasus",
    readMore: "Baca Studi Kasus",
    sectorLabel: "Sektor:",
    clientLocationLabel: "Klien / Lokasi:",
    technologiesLabel: "Teknologi:",
    impactLabel: "Dampak & Hasil Nyata:",
    items: [
      {
        id: "1",
        slug: "enterprise-rag-sap-integration",
        title: "Integrasi Enterprise RAG & AI Copilot pada Sistem ERP SAP",
        client: "Korporasi Manufaktur & Distribusi Nasional",
        industry: "Manufaktur & Rantai Pasok",
        location: "Jakarta, Indonesia",
        service: "Enterprise AI & LLM Integration",
        summary:
          "Implementasi arsitektur Retrieval-Augmented Generation (RAG) aman yang terhubung langsung dengan basis data SAP ERP dan inventaris gudang real-time.",
        challenge:
          "Klien memiliki lebih dari 14 gudang regional dengan ratusan ribu SKU suku cadang dan data transaksi yang tersimpan di server SAP ERP on-premise. Proses pembuatan laporan audit inventaris memakan waktu hingga 4 jam kerja per hari. Staf logistik di lapangan kesulitan mencari ketersediaan barang secara cepat, dan tim eksekutif sering mengalami keterlambatan dalam memperoleh gambaran data rantai pasok secara komprehensif.",
        solution:
          "PT Prima Cipta Artifisial merancang dan menerapkan solusi Enterprise AI Copilot berbasis private RAG (Retrieval-Augmented Generation). Kami membangun konektor aman ke database SAP via protokol REST/RFC terenkripsi, mengonversi data master inventaris ke dalam Qdrant Vector Database, dan mengintegrasikan model Large Language Model (Llama 3 70B) yang berjalan di lingkungan private VPC terisolasi. Seluruh staf kini dapat mengajukan pertanyaan menggunakan Bahasa Indonesia natural seperti 'Berapa sisa stok part X di gudang Surabaya dan kapan estimasi restock?' dan memperoleh jawaban akurat terverifikasi dalam hitungan detik.",
        description:
          "Melalui arsitektur non-intrusif yang dikembangkan oleh PT Prima Cipta Artifisial, sistem integrasi AI ini bekerja di atas lapisan data eksisting tanpa mengubah skema database SAP inti. Setiap permintaan query dari pengguna diverifikasi otorisasi aksesnya (RBAC) secara instan, menghasilkan respons analitik bisnis yang akurat, aman, dan dapat dipertanggungjawabkan.",
        deliverables: [
          "Konektor Sinkronisasi Data SAP ERP & Oracle Real-Time via RFC/REST",
          "Private Vector Database (Qdrant) dengan Enkripsi AES-256 at Rest",
          "Model LLM On-Premise / Private VPC dengan Guardrails Keamanan Data",
          "Antarmuka AI Copilot Web & Mobile dengan Akses Berbasis Peran (RBAC)",
          "Audit Logging & Pemantauan Performa Latensi Query < 1.2 Detik",
          "Sistem Rekomendasi Alokasi Stok Antar-Gudang Berbasis Prediksi Permintaan",
        ],
        impact: [
          "Reduksi waktu pembuatan laporan manajemen dari 4 jam menjadi 15 detik",
          "Akurasi pencarian inventaris suku cadang meningkat menjadi 99.6%",
          "Penghematan biaya operasional query data hingga 45% per bulan",
        ],
        techs: ["Python", "FastAPI", "SAP Connector", "Qdrant Vector DB", "Llama 3 70B", "Docker", "Kubernetes"],
      },
      {
        id: "2",
        slug: "omnichannel-whatsapp-ai-agent",
        title: "Autonomous WhatsApp AI Agent untuk Retail & E-Commerce",
        client: "Jaringan Retail & E-Commerce Nasional",
        industry: "Retail & E-Commerce",
        location: "Surabaya, Indonesia",
        service: "Autonomous Agentic Workflows",
        summary:
          "Pengembangan agen AI multi-tier di WhatsApp Business API yang terintegrasi dengan inventory database, payment gateway, dan CRM HubSpot.",
        challenge:
          "Menghadapi lonjakan lebih dari 30.000 pesan chat harian saat masa promosi, tim customer care klien kewalahan sehingga waktu tunggu pelanggan mencapai lebih dari 45 menit. Chatbot berbasis rule konvensional tidak mampu menangani pertanyaan kompleks, mengecek stok varian secara dinamis, ataupun menyelesaikan proses order checkout.",
        solution:
          "Kami membangun ekosistem Multi-Agent AI pada WhatsApp Cloud API resmi. Agen AI dilengkapi kemampuan penalaran konteks (context-aware reasoning), integrasi live database PostgreSQL untuk memeriksa ketersediaan stok cabang terdekat, integrasi Payment Gateway untuk membuat invoice instan, serta sinkronisasi otomatis ke CRM HubSpot.",
        description:
          "Sistem agen AI kami mampu memahami konteks pelanggan secara mendalam dalam Bahasa Indonesia formal maupun gaul, memberikan rekomendasi produk terpersonalisasi, mengecek stok gudang real-time, hingga memfasilitasi transaksi pembayaran otomatis 24/7.",
        deliverables: [
          "Arsitektur Multi-Agent Autonomous WhatsApp Cloud API",
          "Konektor Real-Time ke Database Inventory & Payment Gateway",
          "Pipeline Pemrosesan Bahasa Alami Bahasa Indonesia Adaptif",
          "Integrasi Tiket Otomatis ke HubSpot CRM & Dashboard Live CSAT",
          "Fallback Handover Mulus ke Agen Manusia untuk Kasus Khusus",
          "Sistem Rekomendasi Produk Berbasis Riwayat Transaksi Pelanggan",
        ],
        impact: [
          "92% percakapan diselesaikan otomatis tanpa agen manusia",
          "Peningkatan konversi penjualan via chat sebesar 24%",
          "Kepuasan pelanggan (CSAT) naik menjadi 4.8 / 5.0",
        ],
        techs: ["Node.js", "WhatsApp Cloud API", "OpenAI GPT-4o", "PostgreSQL", "HubSpot API", "Redis", "Docker"],
      },
      {
        id: "3",
        slug: "intelligent-invoice-logistics",
        title: "Otomasi Ekstraksi Faktur & Dokumen Ekspedisi Cerdas",
        client: "Perusahaan Logistik & Freight Forwarding Multinasional",
        industry: "Logistik & Supply Chain",
        location: "Tanjung Priok, Indonesia",
        service: "Intelligent Document Processing (IDP)",
        summary:
          "Sistem Intelligent Document Processing (IDP) untuk mengekstraksi data Bill of Lading, Invoice Pajak, dan Dokumen Pabean secara otomatis ke sistem Akuntansi.",
        challenge:
          "Proses manual input data ribuan lembar dokumen ekspedisi (Bill of Lading, Packing List, Faktur Pajak, dan Pemberitahuan Impor Barang) memakan waktu rata-rata 3 hari per batch kontainer dengan tingkat kesalahan ketik (*human typo*) mencapai 6.8%, yang sering memicu penalti denda pelabuhan.",
        solution:
          "PT Prima Cipta Artifisial mengimplementasikan pipeline Intelligent Document Processing (IDP) berbasis model Vision-Language (LayoutLMv3) dan OCR adaptif. Sistem ini mampu mengenali lebih dari 20 format dokumen berbeda dalam Bahasa Indonesia dan Inggris, memvalidasi nomor pokok wajib pajak (NPWP) dan total nominal, serta mengekspor data terstruktur langsung ke Oracle Financials.",
        description:
          "Dokumen yang diunggah dipindai secara otomatis, diekstraksi entitas kunci seperti nomor kontainer, tanggal jatuh tempo, dan tarif pabean, lalu divalidasi silang dengan data manifest kapal sebelum disinkronkan ke buku besar akuntansi.",
        deliverables: [
          "Pipeline Vision-LLM & OCR Multiformat untuk Dokumen Logistik",
          "Modul Validasi Otomatis Format Pajak, Pabean & Bill of Lading",
          "Konektor Sinkronisasi Ekspor Data ke Oracle ERP & Database Akuntansi",
          "Human-in-the-Loop Review Dashboard untuk Dokumen Anomali",
          "Audit Trail Enkripsi & Penyimpanan Arsip Digital Terotentikasi",
          "Model Fine-Tuning Mandiri Berbasis Koreksi Pengguna",
        ],
        impact: [
          "Waktu validasi dokumen terpangkas dari 3 hari menjadi 4 menit",
          "Tingkat akurasi ekstraksi data mencapai 99.4%",
          "Penghematan biaya operasional dokumen hingga 60%",
        ],
        techs: ["PyTorch", "LayoutLMv3", "Tesseract OCR", "Docker", "REST API", "Oracle DB", "FastAPI"],
      },
      {
        id: "4",
        slug: "iot-predictive-maintenance",
        title: "Integrasi IoT & AI Prediktif Perawatan Mesin Pabrik",
        client: "Manufaktur Komponen Otomotif",
        industry: "Manufaktur & Otomotif",
        location: "Cikarang, Jawa Barat",
        service: "Computer Vision & Edge AI",
        summary:
          "Pemasangan sensor IoT getaran dan suhu yang terintegrasi dengan model Machine Learning untuk mendeteksi keausan mesin sebelum terjadi kerusakan.",
        challenge:
          "Kerusakan mendadak pada lini stamping mesin pabrik menyebabkan kerugian produksi hingga ratusan juta rupiah per jam. Jadwal perawatan berkala berbasis kalender sering kali tidak efektif mendeteksi keausan bearing mikro yang terjadi di sela-sela shift produksi.",
        solution:
          "Kami menggelar jaringan sensor IoT industri berkecepatan tinggi yang terhubung ke edge computing unit. Model deteksi anomali time-series berbasis Machine Learning menganalisis sinyal getaran dan spektrum termal mesin secara real-time, memberikan peringatan dini hingga 72 jam sebelum potensi kegagalan mekanis fatal terjadi.",
        description:
          "Sistem Edge AI mengolah ratusan titik telemetri per detik langsung di lantai pabrik tanpa memerlukan bandwidth internet besar, dan menyajikan dashboard visualisasi kesehatan mesin kepada tim maintenance pabrik.",
        deliverables: [
          "Jaringan Sensor IoT Getaran & Suhu Berstandar Industri",
          "Unit Pemrosesan Edge AI Menggunakan TensorFlow Lite & Raspberry Pi",
          "Model Deteksi Anomali Time-Series dengan Peringatan 72 Jam Sebelum Rusak",
          "Integrasi Notifikasi Real-Time ke WhatsApp & Sistem SCADA Pabrik",
          "Dashboard Grafana Terpusat untuk Analisis Tren Kesehatan Komponen",
          "Panduan Prosedur Pemeliharaan Preventif Otomatis Berbasis Kondisi Mesin",
        ],
        impact: [
          "Penurunan unplanned downtime mesin hingga 42%",
          "Penghematan biaya perbaikan preventif Rp 2.4 Miliar/tahun",
          "Masa pakai bearing dan komponen mesin meningkat 28%",
        ],
        techs: ["TensorFlow Lite", "MQTT", "Grafana", "TimescaleDB", "Raspberry Pi Industrial", "Python"],
      },
      {
        id: "5",
        slug: "computer-vision-pcb-inspection",
        title: "Inspeksi Visual Cacat Komponen Elektronik (Computer Vision)",
        client: "Pabrik Perakitan Perangkat Elektronik",
        industry: "Elektronik & High-Tech",
        location: "Batam, Indonesia",
        service: "Computer Vision & Edge AI",
        summary:
          "Sistem Computer Vision berkamera resolusi tinggi pada ban berjalan produksi untuk inspeksi solderan PCB dan komponen mikroskopis.",
        challenge:
          "Inspeksi manual mata manusia pada papan sirkuit cetak (PCB) rentan terhadap kelelahan visual ketika lini perakitan berjalan pada kecepatan 100+ unit per menit, mengakibatkan tingkat cacat mikro lolos hingga 1.8% ke tahap pengemasan.",
        solution:
          "Kami memasang kamera optik industri GigE Vision berkecepatan tinggi dengan pencahayaan terkalibrasi, dipadukan dengan model deep learning YOLOv8 dan NVIDIA DeepStream untuk mendeteksi cacat solder bridge, komponen hilang, dan orientasi terbalik secara instan.",
        description:
          "Setiap papan sirkuit yang melintas difoto dan dianalisis dalam tempo 8 milidetik. Papan dengan cacat akan langsung disortir keluar jalur secara otomatis oleh aktuator pneumatik PLC.",
        deliverables: [
          "Sistem Kamera Optik Industri GigE Vision & Pencahayaan Terkalibrasi",
          "Model Deep Learning YOLOv8 Teroptimasi NVIDIA TensorRT",
          "Integrasi Hardware PLC untuk Pemilahan Produk Otomatis",
          "Dashboard Kualitas Produksi Real-Time & Laporan Tingkat Cacat",
          "Database Citra Cacat untuk Audit dan Pelatihan Model Berkelanjutan",
        ],
        impact: [
          "Akurasi deteksi cacat mencapai 99.8%",
          "Kecepatan inspeksi 120 unit per menit tanpa lag",
          "Zero defect lolos ke tahap perakitan akhir",
        ],
        techs: ["OpenCV", "YOLOv8", "NVIDIA DeepStream", "CUDA", "C++", "Industrial GigE Vision"],
      },
      {
        id: "6",
        slug: "dynamic-pricing-retail",
        title: "Engine Penetapan Harga Dinamis & Prediksi Permintaan",
        client: "Distributor FMCG & E-Commerce",
        industry: "FMCG & Distribusi",
        location: "Jakarta, Indonesia",
        service: "Predictive Analytics & Data Science",
        summary:
          "Model analitik prediktif untuk penyesuaian harga kompetitif dan peramalan pasokan barang berbasis tren musiman dan cuaca.",
        challenge:
          "Fluktuasi harga komoditas dan persaingan ketat di marketplace e-commerce menyebabkan marjin keuntungan tergerus jika penetapan harga dilakukan secara manual mingguan. Selain itu, penumpukan stok barang kedaluwarsa sering terjadi akibat ketidakakuratan estimasi pembelian.",
        solution:
          "PT Prima Cipta Artifisial membangun sistem Dynamic Pricing Engine yang mengumpulkan data harga pasar, tren pencarian, elastisitas harga historis, dan stok gudang untuk menghitung rekomendasi harga optimal harian secara otomatis.",
        description:
          "Model machine learning mengevaluasi profitabilitas per kategori produk dan menyesuaikan harga jual secara otomatis sesuai aturan bisnis dan batas marjin minimum yang ditetapkan manajemen.",
        deliverables: [
          "Algoritma Machine Learning Penetapan Harga Dinamis Real-Time",
          "Pipeline ETL Terotomatisasi Menggunakan Apache Airflow & Google BigQuery",
          "Model Prediksi Permintaan Pasokan Musiman 30 Hari ke Depan",
          "Antarmuka Dashboard Interaktif Pengaturan Aturan & Batas Marjin",
          "Sistem Peringatan Dini Penumpukan Stok Gudang Berisiko",
        ],
        impact: [
          "Kenaikan margin profit bersih sebesar 14%",
          "Penurunan dead stock gudang sebesar 28%",
          "Akurasi prediksi penjualan 30 hari ke depan sebesar 94.2%",
        ],
        techs: ["LightGBM", "Scikit-Learn", "Apache Airflow", "BigQuery", "React Dashboard", "Python"],
      },
    ],
  },
  projectDetails: {
    pageTitle: "Detail Studi Kasus",
    overviewTitle: "Ringkasan Eksekutif",
    challengeTitle: "Tantangan Bisnis & Kebutuhan Klien",
    solutionTitle: "Solusi & Arsitektur Integrasi AI",
    architectureHighlights: "Spesifikasi & Cakupan Solusi",
    roiTitle: "Hasil & Dampak Return on Investment (ROI)",
    techStackTitle: "Teknologi & Model AI yang Digunakan",
    serviceLabel: "Layanan :",
    clientLabel: "Klien :",
    locationLabel: "Lokasi :",
    industryLabel: "Industri :",
    solutionScopeTitle: "Spesifikasi & Cakupan Solusi",
    solutionScopeDesc:
      "Untuk mengatasi kendala sistem lama dan skalabilitas, PT Prima Cipta Artifisial merancang dan menggelar arsitektur integrasi komprehensif:",
    solutionDeliverables: [
      "Arsitektur RAG & Vector Database Terisolasi On-Premise",
      "Konektor Sinkronisasi Data SAP ERP Real-Time via REST & RFC",
      "Pipeline NLP Bahasa Indonesia dengan Filter Keamanan Guardrails",
      "Antarmuka Dashboard Analitik Manajemen Eksekutif & Mobile App",
    ],
    roiDesc:
      "Implementasi berhasil diselesaikan tepat waktu dan memberikan peningkatan performa terukur sejak bulan pertama deployment:",
    ctaTitle: "Tertarik Membangun Solusi Serupa untuk Perusahaan Anda?",
    ctaDesc:
      "Konsultasikan kebutuhan integrasi arsitektur AI dan sistem enterprise Anda bersama tim spesialis PT Prima Cipta Artifisial secara gratis.",
  },
  awards: {
    sectionSub: "Kredibilitas & Sertifikasi",
    sectionTitle: "Standar Kualitas & Kepatuhan Enterprise",
    intro:
      "PT Prima Cipta Artifisial mematuhi protokol keamanan data dan standar rekayasa kecerdasan buatan tertinggi untuk menjamin reliabilitas solusi enterprise Anda.",
    items: [
      {
        year: "2024",
        title: "ISO/IEC 27001 Certified Security Pipeline",
        org: "International Organization for Standardization",
        desc: "Sertifikasi manajemen keamanan informasi tingkat enterprise untuk seluruh pipeline dan deployment integrasi AI kami.",
      },
      {
        year: "2024",
        title: "Enterprise AI Solution Partner of the Year",
        org: "Southeast Asia Tech Excellence Forum",
        desc: "Penghargaan inovasi integrasi AI generatif terbaik untuk sektor manufaktur dan rantai pasok korporasi.",
      },
      {
        year: "2023",
        title: "Top Autonomous Agentic Workflow Pioneer",
        org: "Indonesia Digital Innovation Summit",
        desc: "Apresiasi kepemimpinan teknologi dalam pengembangan arsitektur multi-agent AI otomatisasi proses bisnis.",
      },
    ],
  },
  stats: {
    title: "Pencapaian & Kredibilitas Kami",
    subtitle: "Dipercaya oleh berbagai korporasi nasional dan multinasional untuk memimpin transformasi AI",
    items: [
      { number: "50+", label: "Proyek Integrasi AI Sukses" },
      { number: "99.4%", label: "Tingkat Akurasi Model AI" },
      { number: "10x", label: "Peningkatan Efisiensi Alur Kerja" },
      { number: "24/7", label: "Monitoring & Dedicated SLA Support" },
    ],
  },
  faq: {
    sectionSub: "Pertanyaan yang Sering Diajukan",
    title: "Hal yang Perlu Anda Ketahui tentang Integrasi AI Kami",
    items: [
      {
        q: "Bagaimana PT Prima Cipta Artifisial menjamin keamanan dan privasi data perusahaan kami?",
        a: "Keamanan adalah prioritas nomor satu kami. Kami menyediakan opsi deployment on-premise atau private VPC (AWS/Azure/GCP) tanpa membagikan data Anda ke penyedia model pihak ketiga (Zero-Data-Retention policy). Semua data transit dan at-rest dienkripsi dengan standar AES-256 dan kepatuhan RBAC.",
      },
      {
        q: "Berapa lama waktu yang dibutuhkan untuk mengintegrasikan solusi AI ke sistem kami?",
        a: "Tergantung pada kompleksitas alur kerja, tahap Proof of Concept (PoC) biasanya selesai dalam 2–3 minggu, dan implementasi skala penuh siap produksi dalam 6–10 minggu.",
      },
      {
        q: "Apakah kami perlu mengganti sistem software atau database yang saat ini digunakan?",
        a: "Tidak perlu. Solusi integrasi kami dirancang bersifat non-intrusif dan modular, sehingga dapat langsung dihubungkan ke sistem ERP, CRM, database SQL/NoSQL, maupun API internal yang sudah Anda gunakan saat ini.",
      },
      {
        q: "Dukungan apa yang diberikan setelah sistem AI di-deploy ke produksi?",
        a: "Kami menyediakan pemantauan performa 24/7, evaluasi berkala akurasi model (model drift monitoring), fine-tuning lanjutan, serta SLA tanggap darurat teknis.",
      },
    ],
  },
  contact: {
    sectionSub: "Konsultasi AI",
    title: "Siap Mentransformasi Bisnis Anda dengan Integrasi AI?",
    subtitle: "Konsultasikan kebutuhan otomasi dan integrasi AI perusahaan Anda bersama tim spesialis kami hari ini.",
    trustedAgency1: "Mitra Terpercaya",
    trustedAgency2: "Integrasi AI",
    deliveredProjects: "Proyek Integrasi AI Sukses",
    satisfactionRate: "Tingkat Akurasi & Kepuasan Klien",
    formTitle: "Kirim Pesan & Request Konsultasi",
    formSubtitle: "Tim kami akan menghubungi Anda kembali dalam kurun waktu 1x24 jam kerja.",
    nameLabel: "Nama Lengkap*",
    emailLabel: "Alamat Email Korporat*",
    phoneLabel: "Nomor Telepon / WhatsApp*",
    serviceLabel: "Pilih Layanan Integrasi*",
    messageLabel: "Jelaskan Kebutuhan / Kasus Bisnis Anda...",
    filePlaceholder: "Lampirkan File Pendukung...",
    submitBtn: "Kirim Permintaan Konsultasi",
    submitEmailBtn: "Kirim via Email Resmi",
    submitWhatsAppBtn: "Kirim Cepat via WhatsApp",
    emailSending: "Sedang Mengirim ke Email...",
    emailSuccess: "Permintaan konsultasi Anda berhasil dikirim ke email kami!",
    whatsappNotice: "Membuka WhatsApp resmi dengan rincian form Anda...",
    chooseMethod: "Pilih Saluran Pengiriman:",
    successMsg: "Terima kasih! Pesan Anda telah terkirim. Tim kami akan segera menghubungi Anda.",
    serviceOptions: [
      "Enterprise AI & LLM Integration",
      "Autonomous Agentic Workflows",
      "Omnichannel Conversational AI",
      "Intelligent Document Processing (IDP)",
      "Computer Vision & Edge AI",
      "Predictive Analytics & Data Science",
      "Konsultasi & Asesmen Strategi AI",
    ],
    validation: {
      required: "Wajib diisi.",
      email: "Format email tidak valid.",
      numeric: "Harus berupa angka.",
    },
  },
  errorPage: {
    pageTitle: "Halaman Tidak Ditemukan",
    title: "Maaf, Halaman Tidak Ditemukan!",
    desc: "Halaman yang Anda cari mungkin telah dipindahkan, diubah namanya, atau dihapus.",
    backBtn: "Kembali ke Beranda",
  },
  footer: {
    desc: "PT Prima Cipta Artifisial adalah mitra terpercaya dalam integrasi teknologi AI, LLM, dan otomatisasi alur kerja tingkat lanjut untuk korporasi dan institusi di Indonesia.",
    quickLinks: "Tautan Cepat",
    servicesTitle: "Layanan Kami",
    contactTitle: "Hubungi Kantor",
    rights: "Hak Cipta Terpelihara.",
  },
};
